"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskState = void 0;
var TaskState;
(function (TaskState) {
    TaskState["pending"] = "pending";
    TaskState["running"] = "running";
    TaskState["done"] = "done";
    TaskState["error"] = "error";
})(TaskState = exports.TaskState || (exports.TaskState = {}));
//# sourceMappingURL=TaskState.js.map